// extracted by mini-css-extract-plugin
module.exports = {"si-wrapper":"ValidationError_si-wrapper__3LR63","silc-btn":"ValidationError_silc-btn__aBo3Q","root":"ValidationError_root__2BqiA"};